import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {TooltipService} from "@components/tooltip/tooltip.service";
import {TooltipElementDirective} from "@components/tooltip/tooltip-element.directive";
import {combineLatest, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {TooltipContentModel, TooltipPosition} from "@models/tooltip-content-model";
import {JsonPipe, NgForOf, NgStyle} from "@angular/common";
import {SafeHtmlPipe, SanitizerValueType} from "@pipes/safe-html/safe-html.pipe";
import {
  DestinationMapTooltipComponent
} from "@components/destination-map/destination-map-tooltip/destination-map-tooltip.component";

@Component({
  selector: 'app-tooltip',
  standalone: true,
  imports: [
    TooltipElementDirective,
    NgForOf,
    NgStyle,
    SafeHtmlPipe,
    DestinationMapTooltipComponent,
    JsonPipe
  ],
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class TooltipComponent implements OnInit, OnDestroy {

  displayTooltip: boolean = false;
  isDestinationMapTooltip: boolean | undefined = false;
  topPosition: number;
  leftPosition: number;
  tooltipPosition: TooltipPosition;
  content: TooltipContentModel;
  arrowPosition: string;
  maxWidth: string;

  private onDestroy$ = new Subject<void>();

  constructor(
    private tooltipService: TooltipService,
    private cd: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    combineLatest([
      this.tooltipService.displayTooltip,
      this.tooltipService.tooltipConfig,
      this.tooltipService.tooltipContent
    ]).pipe(
      takeUntil(this.onDestroy$)
    ).subscribe(([displayTooltip, tooltipConfig, tooltipContent]) => {
      this.content = tooltipContent;
      this.isDestinationMapTooltip = tooltipContent.isDestinationMapTooltip;
      if (!!tooltipConfig.topPosition && !!tooltipConfig.leftPosition && !!tooltipConfig.tooltipPosition && !!tooltipConfig.arrowPosition && displayTooltip) {
        this.displayTooltip = true;
        this.topPosition = tooltipConfig.topPosition;
        this.leftPosition = tooltipConfig.leftPosition;
        this.tooltipPosition = tooltipConfig.tooltipPosition;
        this.arrowPosition = tooltipConfig.arrowPosition;
        this.maxWidth = tooltipConfig.maxWidth ? tooltipConfig.maxWidth : '236px';
      } else {
        this.displayTooltip = false;
      }
      this.cd.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  protected readonly TooltipPosition = TooltipPosition;
  protected readonly SanitizerValueType = SanitizerValueType;
}
